<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-07-15 11:03:18
 * @LastEditTime: 2021-12-13 10:28:00
 * @LastEditors: chenguobiao
-->
<template>
  <div class="choice-question">
    <question-desc :desc="question.topic" :questionType="questionType" :key="question.uid" :score="question.score"></question-desc>
    <div class="choice-question-wrap">
      <div class="choice-question__image">
        <img :src="question.imgUrl">
      </div>
      <div class="choice-question__choices flex flex-col items-center">
        <div class="choice" v-for="(choice, index) in choices" :key="choice.uid" :class="{choiced: choice.choiced}" @click="handleClick(index)">{{choice.number}}、{{choice.description}}</div>
      </div>
      <replay-detail :question="question" v-if="replay"/>
    </div>
  </div>
</template>

<script>
import store from 'store'
import { WS_GAME_CONFIGS } from '@/config/const'
import QuestionDesc from './QuestionDesc'
import ReplayDetail from './ReplayDetail'
export default {
  props: ['questionType', 'question'],
  components: {
    QuestionDesc,
    ReplayDetail
  },
  data() {
    return {
      choices: [],
      replay: false
    }
  },
  watch: {
    'question.answerList': {
      immediate: true,
      handler(answerList) {
        const replay = store.get(WS_GAME_CONFIGS).replay
        const userAnswerArray = replay ? this.question.userAnswer.split(',') : []
        this.replay = replay
        this.choices = answerList.map(ele => {
          if (replay) {
            ele.choiced = userAnswerArray.indexOf(ele.number) > -1
          } else {
            ele.choiced = false
          }
          return ele
        })
      }
    }
  },
  methods: {
    handleClick(index) {
      if (this.replay) return
      let choices = this.choices
      if (this.questionType !== 'multi_selection') { // 单选
        const findIdx = choices.findIndex(choice => {
          return choice.choiced
        })
        findIdx > -1 && this.$set(this.choices[findIdx], 'choiced', false)
      }
      choices[index].choiced = !choices[index].choiced
      this.choices.splice(index, 1, choices[index])
    }
  },
}
</script>

<style lang="scss" scoped>
  .choice-question {
    &-wrap {
      position: relative;
      ::v-deep {
        .replay-detail {
          position: absolute;
          top: 0;
          right: val(-56);
          transform: translateX(100%);
        }
      }
    }
    &__image {
      margin: 0 auto val(28);
      width: val(412);
    }
    &__choices {
      .choice {
        cursor: pointer;
        width: val(692);
        height: val(56);
        line-height: val(54);
        padding-left: val(29);
        background: #FFFFFF;
        border: 1px solid #3E2C00;
        border-radius: val(38);
        box-sizing: border-box;
        margin-bottom: val(20);
        font-size: val(20);
        font-weight: 500;
        color: #3E2C00;
        &.choiced {
          color: #995D30;
          background: #FFE4C4;
          border-color: #995D30;
        }
      }
    }
  }
</style>
